const en_sales_priceStock = {
    "": "price & stock list",
}

export default en_sales_priceStock;